import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from '@/app/store/store';

import {RolesAccount} from '../auth/constants/AuthConstants';
import {ITokenData} from '../auth/models';

export type RoleType = (typeof RolesAccount)[keyof typeof RolesAccount];

export interface TokenState {
  tokenData: ITokenData | null;
}

const initialState: TokenState = {
  tokenData: null,
};

export const setTokenData = createAsyncThunk<ITokenData, ITokenData>(
  'tokenDataSlice/setTokenData',
  async tokenData => tokenData,
);

export const tokenSlice = createSlice({
  name: 'tokenDataSlice',
  initialState,
  reducers: {
    setTokenData: (state, action: PayloadAction<ITokenData>) => {
      state.tokenData = {...action.payload};
    },
    unSetTokenData: state => {
      state.tokenData = null;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      if (state.tokenData) {
        state.tokenData.accessToken = action.payload;
      }
    },
    refreshAccessToken: (state, action: PayloadAction<string>) => {
      if (state.tokenData) {
        state.tokenData.accessToken = action.payload;
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(setTokenData.fulfilled, (state, action) => {
      state.tokenData = action.payload;
    });
  },
});

export const {
  setTokenData: setTokenDataAction,
  unSetTokenData,
  setAccessToken,
  refreshAccessToken,
} = tokenSlice.actions;

export const selectTokenDataState = (state: RootState): TokenState =>
  state?.tokenDataSlice;
export const selectTokenData = (state: {
  tokenDataSlice: TokenState;
}): ITokenData | null => state?.tokenDataSlice?.tokenData;
export const selectRole = (state: {tokenDataSlice: TokenState}): RoleType =>
  state?.tokenDataSlice?.tokenData?.role;
export const selectToken = (state: {
  tokenDataSlice: TokenState;
}): string | undefined => state?.tokenDataSlice?.tokenData?.accessToken;

export const selectRefreshToken = (state: {
  tokenDataSlice: TokenState;
}): string | undefined => state?.tokenDataSlice?.tokenData?.refreshToken;
export const selectAllTokens = (state: {
  tokenDataSlice: TokenState;
}): {accessToken: string; refreshToken: string} => ({
  accessToken: state?.tokenDataSlice?.tokenData?.accessToken || '',
  refreshToken: state?.tokenDataSlice?.tokenData?.refreshToken || '',
});
export const selectUserRole = (state: {tokenDataSlice: TokenState}) =>
  state.tokenDataSlice.tokenData?.role;

export type TokenSliceActions = typeof tokenSlice.actions;
export default tokenSlice.reducer;
